module.exports = __webpack_public_path__ + "img/aceitar.0ed3d522.png";